import DadosCompra from './DadosCompra';

export default DadosCompra;
